// extracted by mini-css-extract-plugin
export default {"cls1":"zcdANiuTg5atyubNGcf6","cls2":"_lVat6964jw2JSJQoohM zcdANiuTg5atyubNGcf6"};